/**
 * recordingCrypto (Welle 7e / pre100) — client-seitige OpenPGP-Verschlüsselung.
 *
 * Schlüsselhoheit: Die Aufzeichnung wird beim Berater (einziger Klartext-Ort) auf den
 * ÖFFENTLICHEN Schlüssel des Empfängers (Kunde/Bank/Revision) verschlüsselt. Weder Server
 * noch Bamoa können das Paket lesen — nur der Inhaber des privaten Schlüssels. Das Ergebnis
 * ist ein `*.gpg`-Artefakt (binär), wie im Markt-Paket.
 */

import * as openpgp from 'openpgp';

export interface KeyInfo {
  ok: boolean;
  fingerprint?: string;
  userIds?: string[];
}

/** Prüft einen ASCII-armored Public Key und liefert Fingerprint + User-IDs. */
export async function inspectPublicKey(armored: string): Promise<KeyInfo> {
  try {
    const key = await openpgp.readKey({ armoredKey: armored });
    let userIds: string[] = [];
    try { userIds = key.getUserIDs(); } catch { /* */ }
    return { ok: true, fingerprint: key.getFingerprint(), userIds };
  } catch {
    return { ok: false };
  }
}

/** Verschlüsselt Binärdaten auf den Empfänger-Public-Key → binäres OpenPGP-Message-Format. */
export async function encryptToRecipient(armored: string, data: Uint8Array): Promise<Uint8Array> {
  const publicKey = await openpgp.readKey({ armoredKey: armored });
  const message = await openpgp.createMessage({ binary: data });
  const encrypted = await openpgp.encrypt({
    message,
    encryptionKeys: publicKey,
    format: 'binary',
  });
  return encrypted as unknown as Uint8Array;
}
